<template>
  <div>
    <button class="p-2 filter transition-all hover:brightness-125">
      <i v-html="$icons.kebab"></i>
    </button>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
